var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDepartmentIco = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AA62D6CA-5A95-44F7-8D37-58E38ED3BB08") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "department-copy",
    transform: "translate(-355.000000, -34.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.977305,0 C7.15328309,0 -1.93509511e-15,7.15328309 -1.93509511e-15,15.977305 C-1.93509511e-15,24.8013268 7.15328309,31.9546099 15.977305,31.9546099 C24.8013268,31.9546099 31.9546099,24.8013268 31.9546099,15.977305 C31.9442051,7.15759652 24.7970134,0.0104048577 15.977305,0 Z M15.977305,29.0496454 C8.7576507,29.0496454 2.90496454,23.1969592 2.90496454,15.977305 C2.90496454,8.7576507 8.7576507,2.90496454 15.977305,2.90496454 C23.1969592,2.90496454 29.0496454,8.7576507 29.0496454,15.977305 C29.0416406,23.1936409 23.1936409,29.0416406 15.977305,29.0496454 L15.977305,29.0496454 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.977305,4.35744681 C15.1751212,4.35744681 14.5248227,5.00774527 14.5248227,5.80992908 L14.5248227,26.1446809 C14.5248227,26.9468647 15.1751212,27.5971631 15.977305,27.5971631 C22.3947754,27.5971631 27.5971631,22.3947754 27.5971631,15.977305 C27.5971631,9.55983451 22.3947754,4.35744681 15.977305,4.35744681 Z M17.4297872,24.5716426 L17.4297872,7.38296738 C21.6265625,8.08836934 24.7001283,11.7216599 24.7001283,15.977305 C24.7001283,20.23295 21.6265625,23.8662406 17.4297872,24.5716426 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDepartmentIco);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/departmentIco.c8b89efc125e9add97f5674202e79dc3.svg";